import { AuthGraphQLProvider, AuthProvider } from '@codezo/auth';
import App from './App';
import { useAuth } from './hooks/useAuth';

function InitializeApp() {
	const { token } = useAuth();

	return (
		<AuthGraphQLProvider
			token={token || ''}
			uri={import.meta.env.VITE_GRAPHQL_ENDPOINT}
			audience="vetter"
		>
			<App />
		</AuthGraphQLProvider>
	);
}

export default function Initialize() {
	return (
		<AuthProvider>
			<InitializeApp />
		</AuthProvider>
	);
}
